<template>
  <svg
      data-name="レイヤー 1"
      id="レイヤー_1"
      style="width: 20px;height: 25px"
      viewBox="0 0 20 25"
      xmlns="http://www.w3.org/2000/svg"
  >
    <g
        data-name="レイヤー 2"
        id="レイヤー_2"
    >
      <g id="contents">
        <rect
            :style="`fill:${accentColor}`"
            height="3.79"
            rx="1.33"
            width="20"
            y="2.25"
        />
        <rect
            :style="`fill:${accentColor}`"
            height="3.89"
            rx="1.5"
            width="3.15"
            x="8.43"
        />
        <path
            :style="`fill:${accentColor}`"
            d="M17.8,7H2.2a1,1,0,0,0-1,1l1,16.1a1,1,0,0,0,1,.9H16.81a1,1,0,0,0,1-.9l1-16.1a1,1,0,0,0-1-1ZM5.32,22.31H5.27a.87.87,0,0,1-.9-.8L3.82,10.57a.87.87,0,0,1,.85-.89h0a.87.87,0,0,1,1,.75.13.13,0,0,1,0,.06l.55,10.94a.86.86,0,0,1-.84.88Zm5.59-.84a.91.91,0,0,1-1.82,0V10.52a.91.91,0,0,1,1.82,0Zm4.72,0a.87.87,0,0,1-.9.8h-.05a.86.86,0,0,1-.86-.86v0l.55-10.94a.91.91,0,0,1,1.81.08Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "DeleteIcon",
  data() {
    return {
      accentColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
  },
}
</script>

<style>

</style>